// const BASE_URL = 'http://192.168.1.66/submissionsapi/v1';
// // const AUTH_URL = 'http://192.168.1.66/authapi/v1';
// const JOBS_URL = 'http://192.168.1.66/jobsapi/v1';
// // export const AUTH_URL = 'http://192.168.0.127:9009/authapi/v1';
// export const AUTH_URL = 'http://192.168.1.66/authapi/v1';
// export const SUBMISSIONS_URL = BASE_URL;

import { AUTH_URL, JOBS_URL, CANDIDATES_URL, SUBMISSIONS_URL, PYOPS_URL } from './apiConfig';
import { fetchFormGroupsCached, invalidateFormGroupsCache } from './formGroupsCache';
import { getBaseModuleName } from '../utils/modulePath';


const AUTH_TOKEN_KEY = 'authToken';
const AUTH_USER_KEY = 'authUser';
const AUTH_LOGIN_SESSION_KEY = 'authLoginSession';
const LOGIN_STORAGE_KEYS = [
  'access_token',
  'refresh_token',
  'id_token',
  'token_type',
  'expires_in',
  'refresh_expires_in',
  'menu',
  'footermenu',
  'menuPermission',
  'default_values',
  'roleId',
  'companyName',
  'preferred_Username',
  'user_Email',
  'userName',
  'userId',
  'tenantId',
  'businessId',
  'businessUnitId',
  'activeKey',
  'ct_project_id',
  'ct_project_name',
];

const CT_PROJECT_ID_KEY = 'ct_project_id';
const CT_PROJECT_NAME_KEY = 'ct_project_name';

const TEST_FLOW_MODULE = 'test-flows';
const TEST_FLOW_FIELDS = [
  { value: 'module',      label: 'Module',      isVisible: true, type: 'text'   },
  { value: 'flow',        label: 'Flow',        isVisible: true, type: 'text'   },
  { value: 'step_order',  label: 'Step Order',  isVisible: true, type: 'number' },
  { value: 'keyword',     label: 'Action',      isVisible: true, type: 'text'   },
  { value: 'description', label: 'Description', isVisible: true, type: 'text'   },
  { value: 'target',      label: 'Key',         isVisible: true, type: 'text'   },
  { value: 'tags',        label: 'Tags',        isVisible: true, type: 'text'   },
  { value: 'value',       label: 'Value',       isVisible: true, type: 'text'   },
  { value: 'expected',    label: 'Expected',    isVisible: true, type: 'text'   },
];

const LMS_FLOW_MODULE = 'lms-flows';
const LMS_FLOW_FIELDS = [
  { value: 'module',      label: 'Module',      isVisible: true, type: 'text'   },
  { value: 'flow',        label: 'Flow',        isVisible: true, type: 'text'   },
  { value: 'step_order',  label: 'Step Order',  isVisible: true, type: 'number' },
  { value: 'keyword',     label: 'Action',      isVisible: true, type: 'text'   },
  { value: 'description', label: 'Description', isVisible: true, type: 'text'   },
  { value: 'target',      label: 'Key',         isVisible: true, type: 'text'   },
  { value: 'tags',        label: 'Tags',        isVisible: true, type: 'text'   },
  { value: 'value',       label: 'Value',       isVisible: true, type: 'text'   },
  { value: 'expected',    label: 'Expected',    isVisible: true, type: 'text'   },
];

// In-flight login promise — prevents multiple simultaneous login calls
let loginPromise = null;

function extractToken(json) {
  return (
    json?.token ??
    json?.access_token ??
    json?.accessToken ??
    json?.jwt ??
    json?.data?.token ??
    json?.data?.access_token ??
    json?.data?.accessToken ??
    json?.data?.jwt
  );
}

function extractUser(json) {
  return json?.user ?? json?.data?.user ?? json?.data?.profile ?? null;
}

function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;

  try {
    const payload = token.split('.')[1];
    if (!payload) return null;

    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = atob(normalizedPayload.padEnd(Math.ceil(normalizedPayload.length / 4) * 4, '='));
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Unable to decode login token:', error);
    return null;
  }
}

function setLocalStorageJson(key, value) {
  if (value === undefined || value === null) return;
  localStorage.setItem(key, JSON.stringify(value));
}

function getLoginMenus(json, data) {
  return data?.menus ?? json?.menus ?? {
    menu: data?.menu ?? json?.menu,
    footermenu: data?.footermenu ?? json?.footermenu,
  };
}

function persistLoginResponse(json, token, user) {
  const data = json?.data ?? json;
  const tokenPayload = decodeJwtPayload(token) ?? {};
  const menus = getLoginMenus(json, data);
  const userName = (
    user?.userName ??
    user?.name ??
    data?.userName ??
    data?.name ??
    tokenPayload.userName ??
    tokenPayload.name ??
    tokenPayload.preferred_username ??
    tokenPayload.email
  );
  const preferredUsername = (
    user?.preferred_Username ??
    user?.preferred_username ??
    data?.preferred_Username ??
    data?.preferred_username ??
    tokenPayload.preferred_Username ??
    tokenPayload.preferred_username ??
    tokenPayload.email ??
    userName
  );
  const userEmail = user?.email ?? data?.email ?? tokenPayload.email ?? preferredUsername;

  localStorage.setItem('access_token', token);
  if (data?.refresh_token) localStorage.setItem('refresh_token', data.refresh_token);
  if (data?.id_token !== undefined) localStorage.setItem('id_token', data.id_token);
  if (data?.token_type) localStorage.setItem('token_type', data.token_type);
  if (data?.expires_in !== undefined) localStorage.setItem('expires_in', String(data.expires_in));
  if (data?.refresh_expires_in !== undefined) localStorage.setItem('refresh_expires_in', String(data.refresh_expires_in));
  if (userName) localStorage.setItem('userName', userName);
  if (preferredUsername) localStorage.setItem('preferred_Username', preferredUsername);
  if (userEmail) localStorage.setItem('user_Email', userEmail);
  if (data?.roleId ?? tokenPayload.role_id) localStorage.setItem('roleId', data?.roleId ?? tokenPayload.role_id);
  if (data?.companyName) localStorage.setItem('companyName', data.companyName);
  if (tokenPayload.userId !== undefined) localStorage.setItem('userId', String(tokenPayload.userId));
  if (tokenPayload.tenantId) localStorage.setItem('tenantId', tokenPayload.tenantId);
  if (tokenPayload.businessId) localStorage.setItem('businessId', tokenPayload.businessId);
  if (tokenPayload.businessUnitId) localStorage.setItem('businessUnitId', tokenPayload.businessUnitId);

  setLocalStorageJson('menu', menus.menu);
  setLocalStorageJson('footermenu', menus.footermenu);
  setLocalStorageJson('menuPermission', data?.menuPermission);
  setLocalStorageJson('default_values', data?.default_values);
}

export function getStoredToken() {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const hasActiveLoginSession = sessionStorage.getItem(AUTH_LOGIN_SESSION_KEY) === '1';

  return token && hasActiveLoginSession ? token : null;
}

export async function getGroupedVendorHotlist({ jobId, limit = 10, offset = 0, sortBy = 'new', type = 'myVendor' }) {
  const json = await fetchJsonWithAuth(JOBS_URL, '/vendor/hotlist', {
    method: 'POST',
    body: JSON.stringify({ jobId, limit, offset, sortBy, type }),
  });
  return json;
}

export async function getBulkMailDetails(jobId) {
  const json = await fetchJsonWithAuth(CANDIDATES_URL, `/get-bulkmail-details?jobId=${encodeURIComponent(jobId)}`);
  return json.data ?? json;
}

export async function formatMailContentForMail(contents, subject = '') {
  const input = String(contents ?? '').trim();
  if (!input) return '';

  const json = await fetchJsonWithAuth(PYOPS_URL, '/format-mail-content', {
    method: 'POST',
    body: JSON.stringify({ contents: input, subject: String(subject ?? '') }),
  });

  if (json?.status === false) {
    throw new Error(json?.error || 'Unable to format mail content');
  }

  return String(json?.html ?? json?.contents ?? json?.data?.html ?? json?.data?.contents ?? '').trim();
}

// Backward-compatible export for any host code that imported the previous name.
// It now formats the existing mail body rather than generating/re-writing a JD.
export async function formatJobDescriptionForMail(contents, subject = '') {
  return formatMailContentForMail(contents, subject);
}

export async function sendBulkMail({ jobId, toMail, ccMail, bccMail, subject, contents, attachments = [] }) {
  const tenantId = localStorage.getItem('tenantId') || '93c782a4aa626175e5d11afa';
  const businessId = localStorage.getItem('businessId') || '83c782a4aa626175e5d11afa';
  const businessUnitId = localStorage.getItem('businessUnitId') || '63b57588fd768a839dbc0f63';

  const formData = new FormData();
  formData.append('json', JSON.stringify({
    schemaVersion: 1,
    tenantId,
    businessId,
    businessUnitId,
    jobId,
    toMail,
    ccMail,
    bccMail,
    contents,
    subject,
  }));

  // Dynamic document placeholders are resolved to File objects by the mail
  // composer. Append them as multipart files so they are sent as real email
  // attachments instead of being rendered as text inside the mail body.
  (attachments ?? []).forEach((file) => {
    if (file instanceof File) formData.append('attachments', file, file.name);
  });

  // Exclude Content-Type so the browser sets multipart/form-data with the correct boundary
  const allHeaders = await authHeaders();
  const { 'Content-Type': _ct, ...headersWithoutContentType } = allHeaders;

  let res = await fetch(`${CANDIDATES_URL}/send-bulkmail`, {
    method: 'POST',
    headers: headersWithoutContentType,
    body: formData,
  });

  if (res.status === 401) logout();
  if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`);
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}


export function logout() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  LOGIN_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem(AUTH_LOGIN_SESSION_KEY);
  window.dispatchEvent(new Event('auth:logout'));
}

// ---- Role helpers ----
// The login response carries the role NAME in `data.roleId`
// (persistLoginResponse stores it in localStorage['roleId']). The access-token
// claims only have a numeric `role_id`, so the stored role NAME is the reliable
// signal for the tester check. JWT roles are kept as a fallback.
export function getCurrentRoleName() {
  return String(localStorage.getItem('roleId') ?? '').trim().toLowerCase();
}

export function getUserRoles() {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const payload = decodeJwtPayload(token);

  const roles = new Set();

  const stored = getCurrentRoleName();
  if (stored) roles.add(stored);

  if (payload) {
    (payload?.realm_access?.roles ?? []).forEach((role) => roles.add(role));
    Object.values(payload?.resource_access ?? {}).forEach((client) => {
      (client?.roles ?? []).forEach((role) => roles.add(role));
    });
    [payload?.role, payload?.roleName, payload?.role_name].forEach((role) => {
      if (role) roles.add(role);
    });
  }

  return Array.from(roles).map((role) => String(role).toLowerCase());
}

export function isTester() {
  return getCurrentRoleName() === 'tester' || getUserRoles().includes('tester');
}

function isEnabledPermission(value) {
  return value === true || value === 1 || value === '1';
}

export function hasAllJobsPermission() {
  try {
    const permissions = JSON.parse(localStorage.getItem('menuPermission') || '{}');
    if (!permissions || typeof permissions !== 'object') return false;

    const jobsKey = Object.keys(permissions).find((key) => {
      const normalized = String(key).trim().toLowerCase();
      return normalized === 'job' || normalized === 'jobs';
    });
    const jobsPermissions = jobsKey ? permissions[jobsKey] : null;
    if (!jobsPermissions || typeof jobsPermissions !== 'object') return false;

    return isEnabledPermission(
      jobsPermissions.all_jobs
      ?? jobsPermissions.allJobs
      ?? jobsPermissions.alljobs,
    );
  } catch {
    return false;
  }
}

export function resolveJobListScope(requestedScope = '') {
  const scope = String(requestedScope ?? '').trim();

  // Preserve the tab the user actually selected. The API is authoritative
  // for access control and already narrows an unauthorised allJobs request to
  // My Jobs. Re-checking permissions from localStorage here is unreliable:
  // login payloads differ across deployments, so a user whose API response
  // legitimately contains the All Jobs tab could still have that request
  // silently rewritten to myJobs by stale or differently-shaped cached data.
  if (scope === 'myJobs' || scope === 'allJobs' || scope === 'fulfilled') return scope;

  // With no explicit tab, let the API choose the permission-aware default.
  return '';
}

function isJobsModule(module) {
  const baseModule = String(getBaseModuleName(module) ?? '').trim().toLowerCase();
  return baseModule === 'job' || baseModule === 'jobs';
}

// ---- Selected project context (carried through the tester flow) ----
export function setSelectedProject(project) {
  if (!project) return;
  localStorage.setItem(CT_PROJECT_ID_KEY, String(project.id));
  localStorage.setItem(CT_PROJECT_NAME_KEY, String(project.name));
}

export function getSelectedProject() {
  const id = localStorage.getItem(CT_PROJECT_ID_KEY);
  const name = localStorage.getItem(CT_PROJECT_NAME_KEY);
  if (!id || !name) return null;
  return { id: Number(id), name };
}

export function clearSelectedProject() {
  localStorage.removeItem(CT_PROJECT_ID_KEY);
  localStorage.removeItem(CT_PROJECT_NAME_KEY);
}

export async function login(credentials) {
  if (loginPromise) return loginPromise;

  loginPromise = fetch(`${AUTH_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  })
    .then(async (res) => {
      const json = await res.json();
      if (!res.ok) {
        const error = new Error(json?.message ?? json?.error ?? `Login failed: ${res.status}`);
        error.status = res.status;
        throw error;
      }

      const token = extractToken(json);
      if (!token) throw new Error('No token in login response');
      const user = extractUser(json);

      localStorage.setItem(AUTH_TOKEN_KEY, token);
      sessionStorage.setItem(AUTH_LOGIN_SESSION_KEY, '1');
      if (user) localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
      persistLoginResponse(json, token, user);

      return { token, user, response: json };
    })
    .finally(() => {
      loginPromise = null;
    });

  return loginPromise;
}

async function ensureToken() {
  const token = getStoredToken();
  if (token) return token;

  const error = new Error('Authentication required');
  error.status = 401;
  throw error;
}

async function authHeaders() {
  const token = await ensureToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
}

export async function fetchJsonWithAuth(baseUrl, path, options = {}) {
  const headers = await authHeaders();
  const requestOptions = {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  };

  let res = await fetch(`${baseUrl}${path}`, requestOptions);

  if (res.status === 401) {
    logout();
  }

  if (!res.ok) {
    const error = new Error(`API ${res.status}: ${res.statusText}`);
    error.status = res.status;
    throw error;
  }
  return res.json();
}

export async function apiGetWithAuth(baseUrl, path) {
  const json = await fetchJsonWithAuth(baseUrl, path);
  return json.data ?? json;
}

async function apiGet(path) {
  return apiGetWithAuth(SUBMISSIONS_URL, path);
}

async function authapiGet(path) {
  return apiGetWithAuth(AUTH_URL, path);
}

async function authapiPost(path, payload) {
  const json = await fetchJsonWithAuth(AUTH_URL, path, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return json.data ?? json;
}

async function authapiPut(path, payload) {
  const json = await fetchJsonWithAuth(AUTH_URL, path, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  return json.data ?? json;
}

/**
 * Fetch available filter fields for a module.
 * Returns: [{ label, value, type }, ...]
 */
export async function getDropdownFields(module) {
  if (module === TEST_FLOW_MODULE) return TEST_FLOW_FIELDS;
  if (module === LMS_FLOW_MODULE) return LMS_FLOW_FIELDS;

  // Dot-notation names ("job.client") target nested data client-side; the
  // backend only knows the base module.
  return apiGet(`/filter-dropdown-fields?module=${encodeURIComponent(getBaseModuleName(module))}`);
}

export async function getFieldConfig(module, { configType, userId, roleId } = {}) {
  if (module === TEST_FLOW_MODULE) return TEST_FLOW_FIELDS;
  if (module === LMS_FLOW_MODULE) return LMS_FLOW_FIELDS;

  const params = new URLSearchParams({ module: getBaseModuleName(module) });
  if (configType) params.set('configType', configType);
  if (userId != null) params.set('userId', String(userId));
  if (roleId != null) params.set('roleId', String(roleId));
  return authapiGet(`/admin/field-config?${params}`);
}


export async function getTestingOptions(type) {
  return authapiGet(`/testing-modules?type=${encodeURIComponent(type)}`);
}

export async function addTestingOption({ name, type }) {
  return authapiPost('/testing-modules', { name, type });
}

export async function addTestFlow(payload) {
  return authapiPost('/test-flows', payload);
}

export async function getTestFlows({
  limit = 10,
  offset = 0,
  search = '',
  module = '',
  keyword = '',
  tags = '',
  active,
} = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  if (search) params.append('search', search);
  if (module) params.append('module', module);
  if (keyword) params.append('keyword', keyword);
  if (tags) params.append('tags', tags);
  if (active !== undefined && active !== null && active !== '') {
    params.append('active', String(active));
  }

  return authapiGet(`/test-flows?${params.toString()}`);
}

// =====================================================================
// Common Test Automation (znxt_test_automation)
// Hierarchy: Project -> Module -> Submodule -> Test Flow
// =====================================================================

// ---- Projects ----
export async function getCTProjects({ activeOnly = false } = {}) {
  const params = new URLSearchParams();
  if (activeOnly) params.append('active', '1');
  const query = params.toString();
  return authapiGet(`/ct/projects${query ? `?${query}` : ''}`);
}

export async function addCTProject(projectname) {
  return authapiPost('/ct/projects', { projectname });
}

export async function setCTProjectStatus(id, active) {
  return authapiPut('/ct/projects/status', { id, active });
}

// ---- Modules ----
export async function getCTModules({ project = '', activeOnly = false } = {}) {
  const params = new URLSearchParams();
  if (project) params.append('project', project);
  if (activeOnly) params.append('active', '1');
  const query = params.toString();
  return authapiGet(`/ct/modules${query ? `?${query}` : ''}`);
}

export async function addCTModule({ project, modulename }) {
  return authapiPost('/ct/modules', { project, modulename });
}

export async function setCTModuleStatus(id, active) {
  return authapiPut('/ct/modules/status', { id, active });
}

// ---- Submodules ----
export async function getCTSubmodules({ project = '', module = '', activeOnly = false } = {}) {
  const params = new URLSearchParams();
  if (project) params.append('project', project);
  if (module) params.append('module', module);
  if (activeOnly) params.append('active', '1');
  const query = params.toString();
  return authapiGet(`/ct/submodules${query ? `?${query}` : ''}`);
}

export async function addCTSubmodule({ project, modulename, submodulename }) {
  return authapiPost('/ct/submodules', { project, modulename, submodulename });
}

export async function setCTSubmoduleStatus(id, active) {
  return authapiPut('/ct/submodules/status', { id, active });
}

// ---- Test Flows ----
export async function getCTFlows({
  project = '',
  module = '',
  submodule = '',
  product_parent_ID = '',
  module_parent_ID = '',
  submodule_parent_ID = '',
  actions = '',
  search = '',
  active,
  limit = 1000,
  offset = 0,
} = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  const productParentID = product_parent_ID || project;
  const moduleParentID = module_parent_ID || module;
  const submoduleParentID = submodule_parent_ID || submodule;
  if (productParentID) params.append('product_parent_ID', productParentID);
  if (moduleParentID) params.append('module_parent_ID', moduleParentID);
  if (submoduleParentID) params.append('submodule_parent_ID', submoduleParentID);
  if (actions) params.append('actions', actions);
  if (search) params.append('search', search);
  if (active !== undefined && active !== null && active !== '') {
    params.append('active', String(active));
  }
  return authapiGet(`/ct/flows?${params.toString()}`);
}

export async function addCTFlow(payload) {
  return authapiPost('/ct/flows', payload);
}

export async function getCTNextStep({
  project,
  module,
  submodule,
  product_parent_ID,
  module_parent_ID,
  submodule_parent_ID,
}) {
  const params = new URLSearchParams({
    product_parent_ID: String(product_parent_ID || project),
    module_parent_ID: String(module_parent_ID || module),
    submodule_parent_ID: String(submodule_parent_ID || submodule),
  });
  return authapiGet(`/ct/flows/next-step?${params.toString()}`);
}

export async function addLmsFlow(payload) {
  return authapiPost('/lms-flows', payload);
}

export async function getLmsFlows({
  limit = 10,
  offset = 0,
  search = '',
  module = '',
  keyword = '',
  tags = '',
  active,
} = {}) {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  if (search) params.append('search', search);
  if (module) params.append('module', module);
  if (keyword) params.append('keyword', keyword);
  if (tags) params.append('tags', tags);
  if (active !== undefined && active !== null && active !== '') {
    params.append('active', String(active));
  }

  return authapiGet(`/lms-flows?${params.toString()}`);
}

export async function getModuleDataList(module, limit = 10, offset = 0, options = {}) {
  const {
    scope = '',
    sort = '',
    sortDir = '',
    search = '',
    filters = [],
    queryParams = {},
  } = options;

  if (module === TEST_FLOW_MODULE) {
    const data = await getTestFlows({ limit, offset });
    const rows = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total) || 0;

    return {
      items: rows,
      total,
      limit,
      offset,
      tabs: [{ key: 'all', title: 'Test Cases', count: total }],
    };
  }

  if (module === LMS_FLOW_MODULE) {
    const data = await getLmsFlows({ limit, offset });
    const rows = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total) || 0;

    return {
      items: rows,
      total,
      limit,
      offset,
      tabs: [{ key: 'all', title: 'LMS Cases', count: total }],
    };
  }

  const params = new URLSearchParams({
    module: getBaseModuleName(module),
    limit: String(limit),
    offset: String(offset),
  });
  // The shared Jobs page uses the singular module name (`job`) while some
  // consumers use `jobs`. Both names target the same backend module and must
  // go through the same permission-aware My Jobs / All Jobs scope resolver.
  const normalizedScope = isJobsModule(module)
    ? resolveJobListScope(scope)
    : String(scope ?? '').trim();
  if (normalizedScope) params.set('scope', normalizedScope);
  if (sort) params.set('sort', sort);
  if (sortDir) params.set('sortDir', sortDir);
  // Server-side quick search across visible + lookup-resolved fields
  // (job title, client name, location, ...) — see /module-data-list.
  if (String(search ?? '').trim()) params.set('search', String(search).trim());

  const conditions = toFilterConditions(filters.filter((f) => f?.field));
  if (conditions.length) {
    params.set('filters', JSON.stringify(conditions));
  }

  Object.entries(queryParams ?? {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && String(value).trim() !== '') {
      params.set(key, String(value));
    }
  });

  const json = await fetchJsonWithAuth(AUTH_URL, `/module-data-list?${params.toString()}`);

  const responseData = getResponseRows(json);
  const hasObjectSkills = responseData.some((record) => hasObjectSkillItems(record));
  const hasDiceCandidates = responseData.some((record) => hasDiceSource(record));

  if (hasObjectSkills || hasDiceCandidates) {
    try {
      const { transformDiceResponseToInternalFormat } = await import('./diceCandidateMapper');
      const transformed = transformDiceResponseToInternalFormat(json, json);
      const transformedData = transformed?.data?.data ?? [];
      // const total = extractResponseTotal(json, scope || 'internal')
      //   || extractResponseTotal(transformed, scope || 'internal')
      const total = extractResponseTotal(json, normalizedScope)
        || extractResponseTotal(transformed, normalizedScope)
        || transformedData.length;

      return {
        items: transformedData,
        total,
        limit,
        offset,
        tabs: transformed?.data?.tabs ?? json?.tabs ?? json?.data?.tabs ?? [],
        fields: transformed?.data?.fields ?? json?.fields ?? json?.data?.fields ?? [],
        tabField: transformed?.data?.tabField ?? json?.tabField ?? json?.data?.tabField ?? '',
        actionRules: transformed?.data?.actionRules ?? json?.data?.actionRules ?? [],
        actions: transformed?.data?.actions ?? json?.data?.actions ?? [],
        columnActions: transformed?.data?.columnActions ?? json?.data?.columnActions ?? [],
      };
    } catch (error) {
      console.error('[getModuleDataList] Dice transformation failed:', error);
    }
  }
  
  return json;
}

function getResponseRows(response) {
  const payload = response?.data ?? response;
  const rows = Array.isArray(payload)
    ? payload
    : payload?.rows
    ?? payload?.records
    ?? payload?.items
    ?? payload?.list
    ?? payload?.data
    ?? response?.items
    ?? response?.records
    ?? [];

  return Array.isArray(rows) ? rows : [];
}

function firstFiniteNumber(...values) {
  for (const value of values) {
    const number = Number(value);
    if (Number.isFinite(number)) return number;
  }

  return undefined;
}

function extractResponseTotal(response, scope = '') {
  const payload = response?.data ?? response;
  const rows = getResponseRows(response);
  const responseCount = response?.count;
  const payloadCount = payload?.count;
  const normalizedScope = String(scope ?? '').trim().toLowerCase();

  if (responseCount && typeof responseCount === 'object') {
    const total = firstFiniteNumber(
      normalizedScope ? responseCount[normalizedScope] : undefined,
      responseCount.total,
      responseCount.searchCount,
      responseCount.count,
    );
    if (total !== undefined) return total;
  }

  if (payloadCount && typeof payloadCount === 'object') {
    const total = firstFiniteNumber(
      normalizedScope ? payloadCount[normalizedScope] : undefined,
      payloadCount.total,
      payloadCount.searchCount,
      payloadCount.count,
    );
    if (total !== undefined) return total;
  }

  return firstFiniteNumber(
    response?.total,
    typeof responseCount !== 'object' ? responseCount : undefined,
    response?.totalCount,
    payload?.total,
    typeof payloadCount !== 'object' ? payloadCount : undefined,
    payload?.totalCount,
    rows.length,
  ) ?? 0;
}

function hasObjectSkillItems(record) {
  const skills = record?.skills ?? record?.technicalSkills ?? record?.primarySkills;
  if (!Array.isArray(skills) || skills.length === 0) return false;

  return skills.some((skill) => (
    skill
    && typeof skill === 'object'
    && ('skill' in skill || 'lastUsed' in skill)
  ));
}

function hasDiceSource(record) {
  const sourceFields = [
    record?.sourceType,
    record?.profileSource,
    record?.selectedSource,
    record?.customFields?.sourceType,
    record?.customFields?.profileSource,
  ].flat();
  
  return sourceFields.some(
    (value) => String(value ?? '').trim().toLowerCase() === 'dice',
  ) || Boolean(record?.customFields?.diceProfileData);
}

export async function getJobSummary(startDate, endDate) {
  const params = new URLSearchParams();

  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);

  const query = params.toString();
  return apiGetWithAuth(JOBS_URL, `/job-summary${query ? `?${query}` : ''}`);
}

export async function getCandidateSummary(startDate, endDate) {
  const params = new URLSearchParams();

  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);

  const query = params.toString();
  return apiGetWithAuth(CANDIDATES_URL, `/profile-summary${query ? `?${query}` : ''}`);
}

export async function getSubmissionSummary(startDate, endDate) {
  const params = new URLSearchParams();

  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);

  const query = params.toString();
  return apiGetWithAuth(SUBMISSIONS_URL, `/profile-summary${query ? `?${query}` : ''}`);
}

// Converts frontend filter rows to the BE FilterCondition[] format.
// BE ops: eq | ne | in | nin | contains | gt | gte | lt | lte | isEmpty | notEmpty
function toFilterConditions(filterRows) {
  const conditions = [];
  for (const row of filterRows) {
    if (!row.field) continue;

    // The row connector ('and'/'or') between this row and the previous one.
    // 'isEmpty'/'notEmpty' rows use the operator slot for their op type, so they
    // don't have an explicit AND/OR connector — default them to 'and'.
    const rowConnector = row.operator === 'or' ? 'or' : 'and';

    if (row.operator === 'isEmpty') {
      conditions.push({ field: row.field, op: 'isEmpty', operator: 'and' });
      continue;
    }
    if (row.operator === 'notEmpty') {
      conditions.push({ field: row.field, op: 'notEmpty', operator: 'and' });
      continue;
    }

    // Text keyword search → contains (case-insensitive regex on the backend)
    if (row.filterInputType === 'text') {
      const val = typeof row.value === 'string' ? row.value.trim() : '';
      if (val) conditions.push({ field: row.field, op: 'contains', value: val, operator: rowConnector });
      continue;
    }

    // Date range — from/to set by DatePicker.RangePicker.
    // The row connector applies to the first (gte) condition; lte is always
    // AND'd with it so the two bounds stay paired in the backend fold.
    if (row.from || row.to) {
      if (row.from) conditions.push({ field: row.field, op: 'gte', value: String(row.from), operator: rowConnector });
      if (row.to)   conditions.push({ field: row.field, op: 'lte', value: String(row.to),   operator: 'and' });
      continue;
    }

    // Multi-value (dropdown / checkbox / boolean) → in
    if (Array.isArray(row.values) && row.values.length > 0) {
      conditions.push({
        field: row.field,
        op: 'in',
        values: row.values.map(String),
        operator: rowConnector,
        ...(Array.isArray(row.groupFields) && row.groupFields.length > 1 ? { groupFields: row.groupFields } : {}),
      });
    }
  }
  return conditions;
}

/**
 * Fetch distinct values for a specific field in a module.
 * Returns: [{ label, value }, ...]
 */
export async function getDropdownValues(module, field, search = '', meta = {}) {
  const { limit = 50, offset = 0, dataSource, groupName, lookup, groupFields = [], groupSeparator = ' ' } = meta;
  const params = new URLSearchParams({
    module: getBaseModuleName(module),
    field,
    value: search,
    limit: String(limit),
    offset: String(offset),
  });
  if (dataSource) params.set('dataSource', dataSource);
  if (Array.isArray(groupFields) && groupFields.length > 1) {
    params.set('groupFields', groupFields.join(','));
    params.set('groupSeparator', groupSeparator ?? ' ');
  }
  if (dataSource === 'group' && groupName) params.set('groupName', groupName);
  if (dataSource === 'lookup' && lookup?.collection) {
    params.set('lookupCollection', lookup.collection);
    if (lookup.displayField) params.set('lookupField', lookup.displayField);
  }
  return apiGet(`/filter-dropdown-values?${params}`);
}

export async function getDashboardOnboardingCount(
  payload,
  limit = 10,
  offset = 0
) {
  const headers = await authHeaders();

  const response = await fetch(
    `${SUBMISSIONS_URL}/dashboard-onboarding-count?offset=${offset}&limit=${limit}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    }
  );

  const json = await response.json();
  return json.data ?? json;
}

export async function getJobs({
  jobStatus = 'active',
  jobRecruitmentStatus = 'unread',
  limit = 50,
  offset = 0,
  userId = 1,
  sortBy = 'id',
} = {}) {
  const headers = await authHeaders();

  const params = new URLSearchParams({
    jobStatus,
    jobRecruitmentStatus,
    limit: String(limit),
    offset: String(offset),
    userId: String(userId),
    sortBy,
  });

  const response = await fetch(
    `${JOBS_URL}/jobs?${params.toString()}`,
    {
      method: 'GET',
      headers,
    }
  );

  if (!response.ok) {
    throw new Error(`API ${response.status}: ${response.statusText}`);
  }

  const json = await response.json();
  return json.data ?? json;
}


function extractFormGroups(json) {
  const payload = json?.data ?? json;
  const groups = Array.isArray(payload) ? payload
    : Array.isArray(payload?.groups) ? payload.groups
      : Array.isArray(json?.groups) ? json.groups
        : [];
  // The backend attaches the loaded record's audit stamps (createdAt/updatedAt)
  // as recordMeta when an id was supplied. Ride it along on the groups array so
  // callers that only ever see the array (the detail header) can still show
  // "Created on …" without audit fields having to exist as form fields.
  const recordMeta = payload?.recordMeta ?? json?.recordMeta;
  if (recordMeta && typeof recordMeta === 'object') groups.recordMeta = recordMeta;
  return groups;
}

export async function getFormGroups({
  module,
  id,
  view,
} = {}) {
  if (!module) throw new Error('module is required to fetch form groups');

  const headers = await authHeaders();

  const params = new URLSearchParams({
    module,
  });

  // When an id is supplied, the backend embeds each field's actual record value
  // (field.value) in the response, so no separate detail-view call is needed.
  if (id) params.set('id', String(id));

  // `view=detail` opts into detail-view shaping: the backend resolves references
  // to { id, value }, shapes documents into full objects, AND applies the admin
  // Detail-Groups config (label/colour/prefix/hidden/lookups/merges). Without it
  // the admin's customizations never reach the detail view. Forwarded only when
  // provided, so add/edit-form callers keep the raw scalar values.
  if (view) params.set('view', String(view));

  // Shared with the form-side fetcher (services/formGroupsCache): the detail
  // header, the detail body and the form on the same page routinely ask for the
  // SAME payload, and these are 15-60 kB responses. Keyed by the finished URL,
  // which both fetchers build in the same parameter order, so an identical
  // question collapses to one request no matter which of them asked it — and a
  // different `view`/scope stays a different entry.
  const url = `${AUTH_URL}/admin/form-groups?${params.toString()}`;
  const json = await fetchFormGroupsCached(url, async () => {
    const response = await fetch(url, { method: 'GET', headers });
    if (!response.ok) {
      throw new Error(`API ${response.status}: ${response.statusText}`);
    }
    return response.json();
  });
  return extractFormGroups(json);
}

export async function getCandidateFormGroups(options = {}) {
  return getFormGroups({ module: 'candidates', ...options });
}

const MODULE_EDIT_CONFIG = {
    job: {
        fetchUrl: (id) => `${JOBS_URL}/edit/detailed-view/${encodeURIComponent(id)}`,
        updateUrl: (id) => `${JOBS_URL}/edit/${encodeURIComponent(id)}`,
    },
    candidates: {
        fetchUrl: (id) => `${CANDIDATES_URL}/edit/detailed-view?_id=${encodeURIComponent(id)}`,
        updateUrl: (id) => `${CANDIDATES_URL}/update?_id=${encodeURIComponent(id)}`,
    },
};





export async function getRecordForEdit(module, id) {
  if (!module) throw new Error('module is required');
  if (!id) throw new Error('id is required');

  const config = MODULE_EDIT_CONFIG[module];
  if (!config) throw new Error(`No edit config for module: ${module}`);

  const token = await ensureToken();
  const response = await fetch(config.fetchUrl(id), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) throw new Error(`API ${response.status}: ${response.statusText}`);

  const json = await response.json();
  return json.data ?? json;
}






export async function updateRecord(module, id, payload) {
  if (!module) throw new Error('module is required');
  if (!id) throw new Error('id is required');

  const config = MODULE_EDIT_CONFIG[module];
  if (!config) throw new Error(`No edit config for module: ${module}`);

  const token = await ensureToken();

  const formData = new FormData();
  formData.append('json', JSON.stringify(payload));

  const response = await fetch(config.updateUrl(id), {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('[updateRecord] Error response:', errorText);
    throw new Error(errorText || `API ${response.status}: ${response.statusText}`);
  }

  // A successful write makes every cached form-groups payload for this record
  // stale, and the caller usually reads one straight back.
  invalidateFormGroupsCache();

  const json = await response.json();
  return json.data ?? json;
}



export async function uploadJobAttachment(recordId, file) {
  const token = await ensureToken();

  const formData = new FormData();
  formData.append('jobId', recordId);
  formData.append('file', file);

  const response = await fetch(`${JOBS_URL}/jobs/${recordId}/attachment`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      // DO NOT set Content-Type — browser sets it with boundary automatically
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || `API ${response.status}: ${response.statusText}`);
  }

  const json = await response.json();
  return json.data ?? json;
}

export async function addNotes({ notes, notesfor, receiver, notesRelatedId }) {
  const tenantId = localStorage.getItem('tenantId') || '93c782a4aa626175e5d11afa';
  const businessId = localStorage.getItem('businessId') || '83c782a4aa626175e5d11afa';
  const businessUnitId = localStorage.getItem('businessUnitId') || '63b57588fd768a839dbc0f63';

  return fetchJsonWithAuth(JOBS_URL, '/notes', {
    method: 'POST',
    body: JSON.stringify({
      schemaVersion: 1,
      tenantId,
      businessId,
      businessUnitId,
      notes,
      notesfor,
      receiver: receiver ?? [],
      notesRelatedId,
    }),
  });
}

export async function getCandidateGroups() {
  return fetchJsonWithAuth(AUTH_URL, '/masters/dropdown?masterName=candidateGroups&offset=0&limit=50');
}

export async function getSelfAssignData(jobId) {
  return apiGetWithAuth(JOBS_URL, `/self-assign?jobId=${encodeURIComponent(jobId)}`);
}

export async function getManagerUsers() {
  const response = await apiGetWithAuth(JOBS_URL, '/users/manager');
  if (Array.isArray(response)) return response;
  return response ? [response] : [];
}

export async function getRecruiterUsers(managerId = 0) {
  return apiGetWithAuth(JOBS_URL, `/users/recruiter/${encodeURIComponent(managerId)}`);
}

export async function selfAssignJob({ multiJobId, userId, schemaVersion, closureRating, jobPayDetails, priority, priorityFrom, recruitersData }) {
  return fetchJsonWithAuth(JOBS_URL, '/assign?type=self', {
    method: 'PUT',
    body: JSON.stringify({
      multiJobId,
      userId: Number(userId),
      schemaVersion,
      closureRating,
      jobPayDetails,
      priority: String(priority ?? false),
      priorityFrom: priorityFrom ?? '',
      recruitersData: (recruitersData ?? []).map(Number).filter(Number.isInteger),
    }),
  });
}

export async function assignJobToUser({ multiJobId, userId, schemaVersion, closureRating, jobPayDetails, priority, priorityFrom, recruitersData }) {
  return fetchJsonWithAuth(JOBS_URL, '/assign?type=other', {
    method: 'PUT',
    body: JSON.stringify({
      multiJobId,
      userId: Number(userId),
      schemaVersion,
      closureRating,
      jobPayDetails,
      priority: String(priority ?? false),
      priorityFrom: priorityFrom ?? '',
      recruitersData: (recruitersData ?? []).map(Number).filter(Number.isInteger),
    }),
  });
}

export async function addToGroup({ candidateIds, groupId, groupName }) {
  return fetchJsonWithAuth(CANDIDATES_URL, '/actions/update-group', {
    method: 'PUT',
    body: JSON.stringify({ candidateIds, groupId, groupName }),
  });
}


export async function getJobList({ searchQuery, candidateId }) {
  const tenantId = localStorage.getItem('tenantId') || '93c782a4aa626175e5d11afa';
  const businessId = localStorage.getItem('businessId') || '83c782a4aa626175e5d11afa';
  const businessUnitId = localStorage.getItem('businessUnitId') || '63b57588fd768a839dbc0f63';
  const userId = Number(localStorage.getItem('userId')) || 1;

  return fetchJsonWithAuth(JOBS_URL, '/joblist', {
    method: 'POST',
    body: JSON.stringify({
      tenantId,
      businessId,
      businessUnitId,
      searchQuery,
      userId,
      candidateId: Array.isArray(candidateId) ? candidateId : [candidateId],
    }),
  });
}

export async function tagToJob({ multiJobId, applicantId, updateStatus }) {
  const tenantId = localStorage.getItem('tenantId') || '93c782a4aa626175e5d11afa';
  const businessId = localStorage.getItem('businessId') || '83c782a4aa626175e5d11afa';
  const businessUnitId = localStorage.getItem('businessUnitId') || '63b57588fd768a839dbc0f63';
  const userId = Number(localStorage.getItem('userId')) || 9;

  return fetchJsonWithAuth(JOBS_URL, '/source/hiringStgUpdate', {
    method: 'PUT',
    body: JSON.stringify({
      tenantId,
      businessId,
      businessUnitId,
      multiJobId: Array.isArray(multiJobId) ? multiJobId : [multiJobId],
      applicantId: Array.isArray(applicantId) ? applicantId : [applicantId],
      updateStatus: String(updateStatus ?? '').toLowerCase(),
      updateStatusType: 'call',
      responseType: 'responded',
      hiriringStatusChangeType: 'tagToJobs',
      comments: '',
      userId,
    }),
  });
}

export async function deleteJobDetails(jobIds) {
  const tenantId = localStorage.getItem('tenantId') || '93c782a4aa626175e5d11afa';
  const businessId = localStorage.getItem('businessId') || '83c782a4aa626175e5d11afa';
  const businessUnitId = localStorage.getItem('businessUnitId') || '63b57588fd768a839dbc0f63';

  return fetchJsonWithAuth(JOBS_URL, '/delete', {
    method: 'POST',
    body: JSON.stringify({
      schemaVersion: 1,
      tenantId,
      businessId,
      businessUnitId,
      jobId: jobIds,
    }),
  });
}

export async function deleteCandidateData(ids) {
  const results = await Promise.all(
    ids.map((id) => fetchJsonWithAuth(CANDIDATES_URL, `/delete?_id=${encodeURIComponent(id)}`, { method: 'PUT' }))
  );
  return results[results.length - 1] ?? {};
}

export async function deleteModuleData(module, ids) {
  return fetchJsonWithAuth(AUTH_URL, '/module-data-delete', {
    method: 'POST',
    body: JSON.stringify({ module, ids }),
  });
}

export async function getMentionUsers(search = '') {
  const params = search ? `?search=${encodeURIComponent(search)}` : '';
  return apiGetWithAuth(JOBS_URL, `/users/any${params}`);
}

export async function searchCandidates(payload, offset = 0, limit = 10) {
  console.log('[searchCandidates] Called with payload:', JSON.stringify(payload).substring(0, 200));
  
  const json = await fetchJsonWithAuth(
    JOBS_URL,
    `/source/hiring-candidate-list?offset=${offset}&limit=${limit}`,
    { method: 'POST', body: JSON.stringify(payload) }
  );
  
  console.log('[searchCandidates] Response received:', JSON.stringify(json).substring(0, 200));
  
  // Transform Dice responses to match Internal candidate format
  const selectedSource = payload?.selectedSource ?? [];
  const hasDiceSource = Array.isArray(selectedSource) && selectedSource.some(s => String(s).toLowerCase() === 'dice');
  
  console.log('[searchCandidates] selectedSource:', selectedSource);
  console.log('[searchCandidates] hasDiceSource:', hasDiceSource);
  
  if (hasDiceSource) {
    try {
      console.log('[searchCandidates] Dice source detected, transforming response...');
      console.log('[searchCandidates] Raw response structure:', json?.data?.data?.[0] ? Object.keys(json.data.data[0]) : 'No data');
      console.log('[searchCandidates] Raw skills sample:', JSON.stringify(json?.data?.data?.[0]?.skills).substring(0, 150));
      
      const { transformDiceResponseToInternalFormat } = await import('./diceCandidateMapper');
      const transformed = transformDiceResponseToInternalFormat(json, json);
      
      console.log('[searchCandidates] Transformed skills sample:', JSON.stringify(transformed?.data?.data?.[0]?.skills).substring(0, 150));
      console.log('[searchCandidates] Transformation complete');
      
      return transformed;
    } catch (error) {
      console.error('[searchCandidates] Dice transformation failed, returning raw response:', error);
      console.error('[searchCandidates] Error stack:', error.stack);
      // Fall through to return raw response if transformation fails
    }
  } else {
    console.log('[searchCandidates] No Dice source, returning raw response');
  }
  
  return json;
}

export async function getPipelineCount({ jobId, offset = 0, limit = 1, searchValue = '' }) {
  const json = await fetchJsonWithAuth(
    JOBS_URL,
    `/source/hiring-candidate-list/pipeline?hiringType=pipeline&jobId=${jobId}&limit=${limit}&offset=${offset}&searchValue=${encodeURIComponent(searchValue)}`
  );
  return json?.data?.count ?? 0;
}

export async function getShortlistedCount({ jobId, offset = 0, limit = 1, searchQuery = '' }) {
  const json = await fetchJsonWithAuth(
    JOBS_URL,
    `/source/hiring-candidate-list/pipeline?hiringType=shortlisted&jobId=${jobId}&limit=${limit}&offset=${offset}&searchQuery=${encodeURIComponent(searchQuery)}`
  );
  return json?.data?.count ?? 0;
}

export async function getSubmittedCandidates(jobId) {
  const json = await fetchJsonWithAuth(SUBMISSIONS_URL, `/job-submissions?jobId=${jobId}`);
  return json?.data ?? [];
}

export async function getPipelineCandidates({ jobId, offset = 0, limit = 50, searchValue = '' }) {
  const json = await fetchJsonWithAuth(
    JOBS_URL,
    `/source/hiring-candidate-list/pipeline?hiringType=pipeline&jobId=${jobId}&limit=${limit}&offset=${offset}&searchValue=${encodeURIComponent(searchValue)}`
  );
  return json;
}

export async function getShortlistedCandidates({ jobId, offset = 0, limit = 50, searchQuery = '' }) {
  const json = await fetchJsonWithAuth(
    JOBS_URL,
    `/source/hiring-candidate-list/pipeline?hiringType=shortlisted&jobId=${jobId}&limit=${limit}&offset=${offset}&searchQuery=${encodeURIComponent(searchQuery)}`
  );
  return json;
}

export async function quickSubmitDetailedView({ _id, tenantId, businessId, businessUnitId }) {
  const params = new URLSearchParams({ _id, tenantId, businessId, businessUnitId });
  return apiGetWithAuth(CANDIDATES_URL, `/detailed-view?${params.toString()}`);
}


